const actions = {
  SET_STATE: 'auth/SET_STATE',
  FETCH_WHO: 'auth/FETCH_WHO',
  LOGIN: 'auth/LOGIN',
  LOGOUT: 'auth/LOGOUT',
  FORGOT_PASSWORD: 'auth/FORGOT_PASSWORD',
  RESET_PASSWORD: 'auth/RESET_PASSWORD',
  REFRESH_ERRORS: 'auth/REFRESH_ERRORS',
  LOGIN_AS_ADMIN: 'auth/LOGIN_AS_ADMIN',
  LOGIN_AS_SUPER_ADMIN: 'auth/LOGIN_AS_SUPER_ADMIN',
};

export default actions
